module.exports = __webpack_public_path__ + "img/difficult.c7e7c168.jpg";